import CTAButton from '@/components/shared/CTAButton'

const LenderClaimExplanation = ({ lenderName }) => {
  return (
    <section className="py-12 md:py-16">
      <div className="container mx-auto max-w-6xl px-4">
        <h2
          className="mb-6 text-3xl font-bold"
          style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
        >
          What Is a {lenderName} Finance Claim?
        </h2>

        <p
          className="mb-6 text-lg leading-relaxed"
          style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
        >
          A {lenderName} car finance claim is one where you were mis-sold a car
          finance agreement by {lenderName} or the dealership they used. This
          means you may have been charged hidden commissions, given poor advice,
          or not properly informed about the full cost of your car finance deal.
        </p>

        <p
          className="mb-4 text-lg leading-relaxed"
          style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
        >
          Common reasons for a claim include:
        </p>

        <ul
          className="mb-6 list-inside list-disc space-y-2 pl-4 text-lg"
          style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
        >
          <li>Not being told about high interest rates or added fees</li>
          <li>Hidden commission payments between the lender and dealer</li>
          <li>Poor or misleading advice from the salesperson</li>
          <li>Missing or unclear information in your finance agreement</li>
        </ul>

        <p
          className="mb-6 text-lg leading-relaxed"
          style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
        >
          If any of these apply to you, you could be eligible to claim
          compensation. The responsibility falls on {lenderName} and the
          dealership to prove they acted fairly. If they can&apos;t, you may be
          owed a refund.
        </p>

        <p
          className="mb-8 text-lg leading-relaxed"
          style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
        >
          {lenderName} has already set aside hundreds of millions of pounds to
          cover mis-selling claims. Don&apos;t miss the opportunity to check if
          you&apos;re entitled
        </p>

        <div className="text-center">
          <CTAButton />
        </div>
      </div>
    </section>
  )
}

export default LenderClaimExplanation
